/**
 * A mixin to allow any component to be accessed by its name on the window object
 * Only for development. Do not use in production
 */

export default {
  name: 'WindowVars',

  methods: {
    jumpDemo () {
      window.location.href = window.location.href.replace('demo', 'room').replace(this.config.user.username, this.config.classroom.event.slug)
    }
  },

  mounted () {
    // This is generally enough to access components
    window[this.$options.name] = this

    // If a component is used more than once, the previous var will be overwritten. Use it's id for more granual control
    window[this.$options.name + '_' + this._uid] = this

    if (this.$store) {
      window.vuexStore = this.$store
    }
  },

  beforeDestroy () {
    // Remove the reference if the component is destroyed to clear it from memory
    delete window[this.$options.name + '_' + this._uid]
  }
}
